import { useAppSelector, useAppDispatch } from "../../../../hooks";
import { clearSalesRepWriter, getWriterId, setSalesRepWriterId } from "./WriterSlice";
import { salesRepViewBootstrap } from "../../../../Redux/bootstrap/salesRepViewBootstrapSlice";
import { refreshAppBootstrap } from "../../../../Redux/bootstrap/bootstrapSlice";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Loading from "../../../../Components/Loading";
import { Button, Container, FormGroup, Input, } from "reactstrap";
import { analytics } from "../../../../firebase";
import { logEvent } from "firebase/analytics";
import Select, { SingleValue, SingleValueProps } from 'react-select';
import { isDisabled } from "@testing-library/user-event/dist/utils";

export type AccessWriter = {
    accessWriter?: string | null;
    accessWriterBranch?: string | null;
    accessWriterName?: string | null;
    accessWriterUsername?: string | null;
};

const SalesRepView = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const currentWriter = useAppSelector(getWriterId);
    const accessWriters = useAppSelector(
        (state) => state.account.accountArr.accessWriters
    );
    const [selectedWriter, setSelectedWriter] = useState<AccessWriter | null>(null);
    const [value, setValue] = useState<string | undefined>('');
    const [items, setItems] = useState<
        { label: string; value: string }[]
    >([]);
    const loading = useAppSelector((state) => state.salesRepView.loading);

    useEffect(() => {
        console.log(currentWriter)
    }, []);

    const handleSalesRepView = async () => {
        logEvent(analytics, 'view_writer_web', {
            writer_id: value,
        });
        await Promise.all([
            dispatch(setSalesRepWriterId({
                salesRepWriterId: selectedWriter?.accessWriter,
                salesRepWriterName: selectedWriter?.accessWriterName,
                salesRepWriterUsername: selectedWriter?.accessWriterUsername,
                salesRepWriterBranchId: selectedWriter?.accessWriterBranch,
            })),
            dispatch(salesRepViewBootstrap({
                writerId: selectedWriter?.accessWriter,
                username: selectedWriter?.accessWriterUsername,
                branchId: selectedWriter?.accessWriterBranch,
            })),
        ]);
        console.log('Sending analytics event', value);
        
        navigate('/Dashboard');
    };

    const handleLeaveSalesRepView = () => {
        dispatch(clearSalesRepWriter());
        setValue('');
        dispatch(refreshAppBootstrap());
        navigate('/Dashboard');
    };

    const handleSelectItem = (item: SingleValue<{ label: string; value: string; }>) => {
        setValue(item?.value);

        const writer = accessWriters.find(
            (writer: AccessWriter) => writer.accessWriter === item?.value
        );

        setSelectedWriter(writer ?? null);
    };

    useEffect(() => {
        if (accessWriters?.length) {
            setItems(
                accessWriters.map((item: AccessWriter) => ({
                    label: `${item.accessWriter} - ${item.accessWriterName}`,
                    value: item.accessWriter,
                }))
            );
        }
    }, [accessWriters]);

    return (
        <div>
            {loading
                ? (<Loading />)
                : (
                    <Container>
                        <div className="pt-4">
                            <div className="pb-2">
                                <span style={{ left: 25, fontWeight: 'bold', }}>
                                    {
                                        !currentWriter 
                                        ? 'Choose a Writer below' 
                                        : `You are viewing writer ${currentWriter}`
                                    }
                                </span>
                            </div>
                            <div className='text-start'>
                                {/* <FormGroup>
                                    <Input
                                        name="writerDropDown"
                                        type="select"
                                        value={!currentWriter ? value : currentWriter}
                                        onChange={handleSelectItem}
                                    >
                                        <option value="" disabled hidden>
                                            Choose a Writer...
                                        </option>
                                        {items.map((item) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup> */}
                                <Select 
                                    options={items} 
                                    onChange={handleSelectItem}
                                    isDisabled={currentWriter ? true : false}
                                />
                            </div>
                        </div>
                        <div className="pt-4">
                            {(value || currentWriter) && 
                                <Button
                                    className={
                                        !currentWriter
                                        ? 'mainButton'
                                        : 'mainButton bg-danger border-danger text-white'
                                    }
                                    onClick={!currentWriter ? handleSalesRepView : handleLeaveSalesRepView}
                                >
                                    <span className="fw-bold">{!currentWriter ? 'Submit' : 'Leave Rep View'}</span>
                                </Button>
                            }
                        </div>
                    </Container>
                )
            }
        </div>
    );
};

export default SalesRepView;